const MENU = ".js-sp-menu";
const OPEN = ".js-sp-menu-open";
const CLOSE = ".js-sp-menu-close";

const lockScroll = () => {
  const y = window.scrollY;
  document.body.dataset.scrollLock = String(y);
  document.body.style.position = "fixed";
  document.body.style.top = `-${y}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
};

const unlockScroll = () => {
  const y = document.body.dataset.scrollLock;
  document.body.style.removeProperty("position");
  document.body.style.removeProperty("top");
  document.body.style.removeProperty("left");
  document.body.style.removeProperty("right");
  document.body.style.removeProperty("width");
  delete document.body.dataset.scrollLock;
  if (y !== undefined) {
    window.scrollTo(0, Number.parseInt(y, 10) || 0);
  }
};

export const spMenu = () => {
  const menu = document.querySelector(MENU);
  const openBtn = document.querySelector(OPEN);
  const closeBtn = document.querySelector(CLOSE);
  if (!menu || !openBtn || !closeBtn) return;

  const open = () => {
    menu.classList.add("is-open");
    menu.setAttribute("aria-hidden", "false");
    openBtn.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("is-sp-menu-open");
    document.body.classList.add("is-sp-menu-open");
    lockScroll();
    closeBtn.focus();
  };

  const close = () => {
    menu.classList.remove("is-open");
    menu.setAttribute("aria-hidden", "true");
    openBtn.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("is-sp-menu-open");
    document.body.classList.remove("is-sp-menu-open");
    unlockScroll();
    openBtn.focus();
  };

  openBtn.addEventListener("click", (e) => {
    e.preventDefault();
    if (!menu.classList.contains("is-open")) {
      open();
    }
  });

  closeBtn.addEventListener("click", () => {
    close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && menu.classList.contains("is-open")) {
      close();
    }
  });

  // アンカーリンクから先に閉じてからスクロールする（anchorScroll から発火）
  document.addEventListener("spmenu:close", () => {
    if (menu.classList.contains("is-open")) {
      close();
    }
  });
};
